import { render, staticRenderFns } from "./SecuritySettingsCard.vue?vue&type=template&id=7addc8fe&scoped=true"
import script from "./SecuritySettingsCard.vue?vue&type=script&lang=js"
export * from "./SecuritySettingsCard.vue?vue&type=script&lang=js"
import style0 from "./SecuritySettingsCard.vue?vue&type=style&index=0&id=7addc8fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7addc8fe",
  null
  
)

export default component.exports